import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { Fade, Zoom } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import hourglass from '../../../assets/Gifs/hourglass.gif';
const Overlay = () => {
  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 1,
          right: 1,
          bottom: 0,
          borderRadius: '8px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          color: 'grey',
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            animation: 'fadeIn 2s ease-in-out',
            '@keyframes fadeIn': {
              '0%': { opacity: 0 },
              '100%': { opacity: 1 },
            },
          }}
        >
          <Zoom in timeout={1000}>
            <img src={hourglass} style={{ height: '100px', width: '100px', backdropFilter: 'grayscale(100%)' }} />
          </Zoom>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
            Coming Soon
          </Typography>
          <Typography variant="h6" sx={{ mb: 4 }}>
            We are working hard to bring this feature to you. Stay tuned!
          </Typography>
        </Container>
      </Box>
    </Fade>
  );
};

export default Overlay;
